
function $parcel$defineInteropFlag(a) {
  Object.defineProperty(a, '__esModule', {value: true, configurable: true});
}

function $parcel$export(e, n, v, s) {
  Object.defineProperty(e, n, {get: v, set: s, enumerable: true, configurable: true});
}

      var $parcel$global = globalThis;
    var parcelRequire = $parcel$global["parcelRequired477"];
var parcelRegister = parcelRequire.register;
parcelRegister("7TuuZ", function(module, exports) {

$parcel$defineInteropFlag(module.exports);

$parcel$export(module.exports, "default", () => $7058957780fe6ae0$export$2e2bcd8739ae039);
/* prettier-ignore */ /**
 * NOTE:
 *
 * This file is automatically generated by Traduki 2.0.
 * DO NOT CHANGE IT BY HAND or your changes will be lost.
 */ //Spanish (International)
var $7058957780fe6ae0$export$2e2bcd8739ae039 = {
    'fabric.linkPicker.button.cancel': 'Cancelar',
    'fabric.linkPicker.button.insert': 'Insertar',
    'fabric.linkPicker.button.save': 'Guardar',
    'fabric.linkPicker.clearLink': 'Borrar',
    'fabric.linkPicker.clearLinkText': 'Borrar texto',
    'fabric.linkPicker.hyperlink.searchLinkResults': '{count, plural, =0 {no hay resultados} one {{count,number} resultado encontrado} other {{count,number} resultado encontrado}}',
    'fabric.linkPicker.linkAriaLabel': 'Escribe o pega un enlace en el campo',
    'fabric.linkPicker.linkHelperTextAriaLabel': 'Enlace de texto auxiliar que se muestra',
    'fabric.linkPicker.linkHelperTextLabel': "Ponle un t\xedtulo o una descripci\xf3n a este enlace",
    'fabric.linkPicker.linkInvalid': "Introduce una URL v\xe1lida.",
    'fabric.linkPicker.linkLabel': 'Enlace',
    'fabric.linkPicker.linkPlaceholder': 'Pegar un enlace',
    'fabric.linkPicker.linkTextAriaLabel': 'Enlace de texto que se muestra',
    'fabric.linkPicker.linkTextLabel': 'Texto que se muestra (opcional)',
    'fabric.linkPicker.linkTextPlaceholder': 'Texto que se debe mostrar',
    'fabric.linkPicker.listTitle.recentlyViewed': 'Historial reciente',
    'fabric.linkPicker.listTitle.results': 'Resultados',
    'fabric.linkPicker.noEmbed': "La vista incrustada no es compatible con este enlace. <a>Se puede encontrar m\xe1s informaci\xf3n sobre por qu\xe9 algunos enlaces inteligentes no muestran contenido aqu\xed.</a>",
    'fabric.linkPicker.search.error.description': "Actualiza la p\xe1gina o ponte en contacto con el <a>soporte de Atlassian</a> si sigue ocurriendo.",
    'fabric.linkPicker.search.error.heading': 'Tenemos problemas para cargar los datos.',
    'fabric.linkPicker.search.error.retry': 'Actualizar',
    'fabric.linkPicker.search.linkAriaLabel': "Las sugerencias aparecer\xe1n abajo a medida que escribas en el campo",
    'fabric.linkPicker.search.linkLabel': 'Busca o pega un enlace',
    'fabric.linkPicker.search.linkPlaceholder': 'Busca enlaces recientes o pega un nuevo enlace',
    'fabric.linkPicker.search.noResults.description': "Prueba con otro t\xe9rmino.",
    'fabric.linkPicker.search.noResults.heading': "No se ha podido encontrar nada que coincida con tu b\xfasqueda.",
    'fabric.linkPicker.status.submitting': 'Enviando',
    'fabric.linkPicker.time.message.updated': "\xdaltima actualizaci\xf3n: {time}",
    'fabric.linkPicker.time.message.viewed': 'Visto: {time}',
    'fabric.linkPicker.unhandledError.description': "Prueba volviendo a cargar la p\xe1gina.",
    'fabric.linkPicker.unhandledError.heading': 'Algo ha ido mal.'
};

});


//# sourceMappingURL=es.7aa44ce6.js.map
